import { GETRMDETAILS, GETRMDETAILS_ERROR, GETRMDETAILS_HIDE_ERROR, GETRMDETAILS_START_LOADER, GETRMDETAILS_STOP_LOADER } from "../interface/IGetRmDetails";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const GetRmDetailsReducer = (state = initState, action) => {
    switch (action.type) {
        case GETRMDETAILS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case GETRMDETAILS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case GETRMDETAILS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case GETRMDETAILS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case GETRMDETAILS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default GetRmDetailsReducer;
